<script lang="ts">
	import { page } from '$app/stores';
	$: cmp = $page.data?.cmp?.html;
</script>

<svelte:head>
	<!-- eslint-disable-next-line svelte/no-at-html-tags -->
	{@html cmp}
</svelte:head>
